import React from 'react';

function HoverAgendaIcon() {
	return (
	<svg  className="eagerlyicon" width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M0 13.5294C0 6.05732 6.05732 0 13.5294 0H32.4706C39.9427 0 46 6.05732 46 13.5294V46H13.5294C6.05732 46 0 39.9427 0 32.4706V13.5294ZM21 9H24V21H36V24H24V36H21V24H9V21H21V9Z" fill="#1E1E1E"/>
	</svg>
	)
}
export default HoverAgendaIcon;
